/**
 * Commune data by canton code.
 * Complete list of all Swiss communes (municipalities) as of January 1, 2025.
 * Sources: Swiss Federal Statistical Office, citypopulation.de, Wikipedia.
 *
 * Used by the OnboardingWizard to provide a dropdown for commune selection.
 */

const COMMUNES_BY_CANTON: Record<string, string[]> = {
  ZH: [
    'Adliswil', 'Aesch (ZH)', 'Aeugst am Albis', 'Affoltern am Albis', 'Altikon',
    'Andelfingen', 'Bachs', 'Bäretswil', 'Bassersdorf', 'Bauma',
    'Benken (ZH)', 'Berg am Irchel', 'Birmensdorf (ZH)', 'Bonstetten', 'Boppelsen',
    'Brütten', 'Bubikon', 'Buch am Irchel', 'Buchs (ZH)', 'Bülach',
    'Dachsen', 'Dällikon', 'Dänikon', 'Dättlikon', 'Dielsdorf',
    'Dietikon', 'Dietlikon', 'Dinhard', 'Dorf', 'Dübendorf',
    'Dürnten', 'Egg', 'Eglisau', 'Elgg', 'Ellikon an der Thur',
    'Elsau', 'Embrach', 'Erlenbach (ZH)', 'Fällanden', 'Fehraltorf',
    'Feuerthalen', 'Fischenthal', 'Flurlingen', 'Freienstein-Teufen', 'Geroldswil',
    'Glattfelden', 'Gossau (ZH)', 'Greifensee', 'Grüningen', 'Hagenbuch',
    'Hausen am Albis', 'Hedingen', 'Henggart', 'Herrliberg', 'Hettlingen',
    'Hinwil', 'Hirzel', 'Hittnau', 'Hochfelden', 'Hofstetten (ZH)',
    'Hombrechtikon', 'Horgen', 'Höri', 'Humlikon', 'Hüntwangen',
    'Hüttikon', 'Illnau-Effretikon', 'Kappel am Albis', 'Kilchberg (ZH)', 'Kleinandelfingen',
    'Kloten', 'Knonau', 'Küsnacht (ZH)', 'Kyburg', 'Langnau am Albis',
    'Laufen-Uhwiesen', 'Lindau', 'Lufingen', 'Männedorf', 'Marthalen',
    'Maschwanden', 'Maur', 'Meilen', 'Mettmenstetten', 'Mönchaltorf',
    'Neerach', 'Neftenbach', 'Niederglatt', 'Niederhasli', 'Niederweningen',
    'Nürensdorf', 'Oberembrach', 'Oberengstringen', 'Oberglatt', 'Oberrieden',
    'Oberstammheim', 'Oberweningen', 'Obfelden', 'Oetwil am See', 'Oetwil an der Limmat',
    'Opfikon', 'Ossingen', 'Otelfingen', 'Ottenbach', 'Pfäffikon',
    'Pfungen', 'Rafz', 'Regensberg', 'Regensdorf', 'Rheinau',
    'Richterswil', 'Rickenbach (ZH)', 'Rifferswil', 'Rorbas', 'Rümlang',
    'Rüschlikon', 'Russikon', 'Rüti (ZH)', 'Schlatt (ZH)', 'Schleinikon',
    'Schlieren', 'Schöfflisdorf', 'Schönenberg (ZH)', 'Schwerzenbach', 'Seegräben',
    'Seuzach', 'Stallikon', 'Stammheim', 'Steinmaur', 'Stäfa',
    'Thalheim an der Thur', 'Thalwil', 'Trüllikon', 'Truttikon', 'Turbenthal',
    'Uetikon am See', 'Uitikon', 'Unterengstringen', 'Unterstammheim', 'Urdorf',
    'Uster', 'Volken', 'Volketswil', 'Wädenswil', 'Wald (ZH)',
    'Wallisellen', 'Wangen-Brüttisellen', 'Wasterkingen', 'Weiningen (ZH)', 'Weisslingen',
    'Wettswil am Albis', 'Wiesendangen', 'Wil (ZH)', 'Wila', 'Wildberg',
    'Winkel', 'Winterthur', 'Zell (ZH)', 'Zollikon', 'Zumikon',
    'Zürich',
  ],
  BE: [
    'Aarberg', 'Aarwangen', 'Adelboden', 'Aegerten', 'Aefligen',
    'Affoltern im Emmental', 'Amsoldingen', 'Arch', 'Arni (BE)', 'Attiswil',
    'Auswil', 'Bangerten', 'Bannwil', 'Bargen (BE)', 'Bätterkinden',
    'Beatenberg', 'Belp', 'Belprahon', 'Berken', 'Bern',
    'Bettenhausen', 'Biel/Bienne', 'Biglen', 'Bleienbach', 'Blumenstein',
    'Bolligen', 'Bolligen', 'Boltigen', 'Bowil', 'Brienz (BE)',
    'Brienzwiler', 'Brügg', 'Brüttelen', 'Buchholterberg', 'Büetigen',
    'Bühl', 'Büren an der Aare', 'Büren zum Hof', 'Burgdorf', 'Burgistein',
    'Busswil bei Büren', 'Clavaleyres', 'Court', 'Courtelary', 'Cremines',
    'Därstetten', 'Deisswil bei Münchenbuchsee', 'Diemtigen', 'Dotzigen', 'Dürrenroth',
    'Eggiwil', 'Einigen', 'Emmenmatt', 'Epsach', 'Erlenbach im Simmental',
    'Erlach', 'Eschert', 'Evilard', 'Fahrni', 'Faulensee',
    'Ferenbalm', 'Finsterhennen', 'Forst-Längenbühl', 'Fraubrunnen', 'Frauenkappelen',
    'Freimettigen', 'Frenke', 'Frenkendorf', 'Frutigen', 'Gadmen',
    'Gals', 'Gampelen', 'Gelterfingen', 'Gerzensee', 'Gondiswil',
    'Grandval', 'Grindelwald', 'Grossaffoltern', 'Grosshöchstetten', 'Grünenmatt',
    'Gsteig', 'Gsteigwiler', 'Guggisberg', 'Gümligen', 'Gurzelen',
    'Gutenburg', 'Guttannen', 'Habkern', 'Häutligen', 'Hasle bei Burgdorf',
    'Heimberg', 'Heimenhausen', 'Heimiswil', 'Hellsau', 'Herbligen',
    'Herzogenbuchsee', 'Hilterfingen', 'Hindelbank', 'Höchstetten', 'Hofstetten bei Brienz',
    'Höfen', 'Homberg', 'Horrenbach-Buchen', 'Huttwil', 'Iffwil',
    'Inkwil', 'Innertkirchen', 'Ins', 'Interlaken', 'Ipsach',
    'Ittigen', 'Jaberg', 'Jegenstorf', 'Kandergrund', 'Kandersteg',
    'Kaufdorf', 'Kehrsatz', 'Kernenried', 'Kirchberg (BE)', 'Kirchdorf (BE)',
    'Kirchlindach', 'Kiesen', 'Köniz', 'Konolfingen', 'Koppigen',
    'Krattigen', 'Krauchthal', 'Kriechenwil', 'Langenthal', 'Langnau im Emmental',
    'Lauperswil', 'Lauterbrunnen', 'Leissigen', 'Lengnau (BE)', 'Lenk',
    'Leuzigen', 'Ligerz', 'Linden', 'Lotzwil', 'Lüscherz',
    'Lütschental', 'Lützelflüh', 'Lyss', 'Lyssach', 'Madiswil',
    'Matten bei Interlaken', 'Mattstetten', 'Meikirch', 'Meiringen', 'Melchnau',
    'Merligen', 'Messen', 'Mirchel', 'Mörigen', 'Moosseedorf',
    'Münchenbuchsee', 'Münchenwiler', 'Münchringen', 'Münsingen', 'Müntschemier',
    'Muri bei Bern', 'Mürren', 'Mühleberg', 'Naters', 'Nidau',
    'Niedermuhlern', 'Niederönz', 'Niederstocken', 'Nods', 'Oberbalm',
    'Oberbipp', 'Oberburg', 'Oberdiessbach', 'Oberhünigen', 'Oberhofen am Thunersee',
    'Oberlangenegg', 'Oberried am Brienzersee', 'Obersteckholz', 'Oberthal', 'Oberwil bei Büren',
    'Ochlenberg', 'Oppligen', 'Orpund', 'Ostermundigen', 'Péry-La Heutte',
    'Pieterlen', 'Plateau de Diesse', 'Pohlern', 'Port', 'Radelfingen',
    'Rapperswil (BE)', 'Reconvilier', 'Reichenbach im Kandertal', 'Renan (BE)', 'Riggisberg',
    'Ringgenberg (BE)', 'Roggwil (BE)', 'Rohrbach', 'Rohrbachgraben', 'Röthenbach im Emmental',
    'Rubigen', 'Rüderswil', 'Rüdtligen-Alchenflüh', 'Rüegsau', 'Rümligen',
    'Rüschegg', 'Rüti bei Büren', 'Rüti bei Lyssach', 'Saanen', 'Saicourt',
    'Saint-Imier', 'Sangernboden', 'Säriswil', 'Schangnau', 'Scheuren',
    'Schlosswil', 'Schwanden bei Brienz', 'Schwarzenburg', 'Schwarzhäusern', 'Seedorf (BE)',
    'Seeberg', 'Seftigen', 'Sigriswil', 'Siselen', 'Sonceboz-Sombeval',
    'Sonvilier', 'Sorvilier', 'Spiez', 'Steffisburg', 'Stocken-Höfen',
    'Studen (BE)', 'Sumiswald', 'Sundlauenen', 'Sutz-Lattrigen', 'Tavannes',
    'Teuffenthal (BE)', 'Thierachern', 'Thörigen', 'Thun', 'Thunstetten',
    'Toffen', 'Trachselwald', 'Tramelan', 'Trub', 'Tschugg',
    'Twann-Tüscherz', 'Uebeschi', 'Uetendorf', 'Unterseen', 'Unterlangenegg',
    'Urtenen-Schönbühl', 'Uttigen', 'Utzenstorf', 'Vechigen', 'Villeret',
    'Vinelz', 'Wachseldorn', 'Walkringen', 'Walperswil', 'Wangen an der Aare',
    'Wangenried', 'Wattenwil', 'Wengi', 'Wichtrach', 'Wiedlisbach',
    'Wiggiswil', 'Wilderswil', 'Wileroltigen', 'Wimmis', 'Wohlen bei Bern',
    'Worb', 'Worben', 'Wynau', 'Wynigen', 'Wyssachen',
    'Zäziwil', 'Zollikofen', 'Zuzwil (BE)', 'Zweisimmen', 'Zwieselberg',
  ],
  LU: [
    'Adligenswil', 'Aesch (LU)', 'Alberswil', 'Altbüron', 'Altishofen',
    'Beromünster', 'Buchrain', 'Büron', 'Buttisholz', 'Dagmersellen',
    'Dierikon', 'Doppleschwand', 'Ebersecken', 'Ebikon', 'Egolzwil',
    'Eich', 'Emmen', 'Entlebuch', 'Ermensee', 'Eschenbach (LU)',
    'Escholzmatt-Marbach', 'Ettiswil', 'Fischbach (LU)', 'Flühli', 'Gettnau',
    'Geuensee', 'Gisikon', 'Greppen', 'Grossdietwil', 'Grosswangen',
    'Hasle (LU)', 'Hellbühl', 'Hergiswil bei Willisau', 'Hildisrieden', 'Hitzkirch',
    'Hohenrain', 'Honau', 'Horw', 'Inwil', 'Knutwil',
    'Kriens', 'Luthern', 'Luzern', 'Malters', 'Mauensee',
    'Meggen', 'Meierskappel', 'Menznau', 'Nebikon', 'Neuenkirch',
    'Nottwil', 'Oberkirch (LU)', 'Pfaffnau', 'Rain', 'Rickenbach (LU)',
    'Roggliswil', 'Romoos', 'Root', 'Rothenburg', 'Ruswil',
    'Schenkon', 'Schlierbach', 'Schongau', 'Schötz', 'Schüpfheim',
    'Schwarzenberg (LU)', 'Sempach', 'Sursee', 'Triengen', 'Udligenswil',
    'Ufhusen', 'Vitznau', 'Wauwil', 'Weggis', 'Werthenstein',
    'Wikon', 'Willisau', 'Wolhusen', 'Zell (LU)',
  ],
  UR: [
    'Altdorf (UR)', 'Andermatt', 'Attinghausen', 'Bürglen (UR)', 'Erstfeld',
    'Flüelen', 'Göschenen', 'Gurtnellen', 'Hospental', 'Isenthal',
    'Realp', 'Schattdorf', 'Seedorf (UR)', 'Seelisberg', 'Silenen',
    'Sisikon', 'Spiringen', 'Unterschächen', 'Wassen',
  ],
  SZ: [
    'Alpthal', 'Arth', 'Einsiedeln', 'Feusisberg', 'Freienbach',
    'Galgenen', 'Gersau', 'Höfe', 'Illgau', 'Ingenbohl',
    'Innerthal', 'Küssnacht (SZ)', 'Lachen (SZ)', 'Lauerz', 'Morschach',
    'Muotathal', 'Oberiberg', 'Reichenburg', 'Riemenstalden', 'Rothenthurm',
    'Sattel', 'Schübelbach', 'Schwyz', 'Steinen', 'Steinerberg',
    'Tuggen', 'Unteriberg', 'Vorderthal', 'Wangen (SZ)', 'Wollerau',
  ],
  OW: [
    'Alpnach', 'Engelberg', 'Giswil', 'Kerns', 'Lungern',
    'Sachseln', 'Sarnen',
  ],
  NW: [
    'Beckenried', 'Buochs', 'Dallenwil', 'Emmetten', 'Ennetbürgen',
    'Ennetmoos', 'Hergiswil (NW)', 'Oberdorf (NW)', 'Stans', 'Stansstad',
    'Wolfenschiessen',
  ],
  GL: [
    'Glarus', 'Glarus Nord', 'Glarus Süd',
  ],
  ZG: [
    'Baar', 'Cham', 'Hünenberg', 'Menzingen', 'Neuheim',
    'Oberägeri', 'Risch', 'Steinhausen', 'Unterägeri', 'Walchwil',
    'Zug',
  ],
  FR: [
    'Alterswil', 'Arconciel', 'Attalens', 'Auboranges', 'Autafond',
    'Autigny', 'Avry', 'Bas-Intyamon', 'Belmont-Broye', 'Billens-Hennens',
    'Bois-d\'Amont', 'Bösingen', 'Botterens', 'Broc', 'Bröye',
    'Bulle', 'Chapelle (Glâne)', 'Châtel-Saint-Denis', 'Châtel-sur-Montsalvens', 'Châtillon (FR)',
    'Châtonnaye', 'Chénens', 'Chevrilles', 'Corbières', 'Courgevaux',
    'Courtepin', 'Cressier (FR)', 'Cugy (FR)', 'Delley-Portalban', 'Düdingen',
    'Echarlens', 'Ecuvillens', 'Estavayer', 'Farvagny', 'Ferpicloz',
    'Flamatt', 'Fräschels', 'Fribourg', 'Gibloux', 'Giffers',
    'Givisiez', 'Gletterens', 'Granges (Veveyse)', 'Granges-Paccot', 'Greng',
    'Gruyères', 'Gurmels', 'Guin', 'Hauterive (FR)', 'Hauteville',
    'Haut-Intyamon', 'Heitenried', 'Jaun', 'Kerzers', 'La Brillaz',
    'La Folliaz', 'La Roche', 'La Sonnaz', 'La Verrerie', 'Le Châtelard',
    'Le Crêt', 'Le Flon', 'Le Glèbe', 'Le Mouret', 'Le Pâquier (FR)',
    'Les Montets', 'Léchelles', 'Lully (FR)', 'Marly', 'Marsens',
    'Matran', 'Mézières (FR)', 'Middes', 'Misery-Courtion', 'Montagny (FR)',
    'Mont-Vully', 'Morlon', 'Murist', 'Murten', 'Neyruz (FR)',
    'Nuvilly', 'Oberschrot', 'Pérolles', 'Pierrafortscha', 'Plaffeien',
    'Pont-en-Ogoz', 'Pont-la-Ville', 'Prez', 'Rechthalten', 'Remaufens',
    'Riaz', 'Ried bei Kerzers', 'Romont (FR)', 'Rue', 'Saint-Aubin (FR)',
    'Saint-Martin (FR)', 'Sâles', 'Schmitten (FR)', 'Semsales', 'Sévaz',
    'Siviriez', 'Sorens', 'St. Antoni', 'St. Silvester', 'St. Ursen',
    'Surpierre', 'Tafers', 'Treyvaux', 'Ulmiz', 'Ueberstorf',
    'Val-de-Charmey', 'Vaulruz', 'Villarimboud', 'Villars-sur-Glâne', 'Villaz',
    'Villorsonnens', 'Vuadens', 'Vuisternens-devant-Romont', 'Wünnewil-Flamatt',
  ],
  SO: [
    'Aedermannsdorf', 'Aeschi (SO)', 'Balm bei Günsberg', 'Balsthal', 'Bärschwil',
    'Bättwil', 'Beinwil (SO)', 'Bellach', 'Bettlach', 'Biberist',
    'Biezwil', 'Bolken', 'Boningen', 'Breitenbach', 'Buchegg',
    'Büren (SO)', 'Büsserach', 'Däniken', 'Deitingen', 'Derendingen',
    'Dornach', 'Drei Höfe', 'Dulliken', 'Egerkingen', 'Eppenberg-Wöschnau',
    'Erlinsbach (SO)', 'Erschwil', 'Etziken', 'Fehren', 'Feldbrunnen-St. Niklaus',
    'Flumenthal', 'Fulenbach', 'Gempen', 'Gerlafingen', 'Grenchen',
    'Gretzenbach', 'Grindel', 'Günsberg', 'Gunzgen', 'Hägendorf',
    'Halten', 'Härkingen', 'Hauenstein-Ifenthal', 'Herbetswil', 'Himmelried',
    'Hochwald', 'Hofstetten-Flüh', 'Holderbank (SO)', 'Horriwil', 'Hubersdorf',
    'Hüniken', 'Kammersrohr', 'Kappel (SO)', 'Kestenholz', 'Kienberg',
    'Kleinlützel', 'Kriegstetten', 'Langendorf', 'Laupersdorf', 'Lohn-Ammannsegg',
    'Lommiswil', 'Lostorf', 'Lüsslingen-Nennigkofen', 'Luterbach', 'Lüterkofen-Ichertswil',
    'Matzendorf', 'Meltingen', 'Messen', 'Metzerlen-Mariastein', 'Mümliswil-Ramiswil',
    'Neuendorf', 'Niederbuchsiten', 'Niedergösgen', 'Nuglar-St. Pantaleon', 'Nunningen',
    'Oberbuchsiten', 'Oberdorf (SO)', 'Obergerlafingen', 'Obergösgen', 'Oekingen',
    'Oensingen', 'Olten', 'Recherswil', 'Rickenbach (SO)', 'Riedholz',
    'Rodersdorf', 'Rüttenen', 'Schnottwil', 'Schönenwerd', 'Seewen',
    'Selzach', 'Solothurn', 'Starrkirch-Wil', 'Stüsslingen', 'Subingen',
    'Trimbach', 'Unterramsern', 'Walterswil (SO)', 'Wangen bei Olten', 'Welschenrohr-Gänsbrunnen',
    'Winznau', 'Wisen (SO)', 'Witterswil', 'Wolfwil', 'Zuchwil',
    'Zullwil',
  ],
  BS: [
    'Basel', 'Bettingen', 'Riehen',
  ],
  BL: [
    'Aesch (BL)', 'Allschwil', 'Anwil', 'Arboldswil', 'Arisdorf',
    'Arlesheim', 'Augst', 'Bennwil', 'Biel-Benken', 'Binningen',
    'Birsfelden', 'Blauen', 'Böckten', 'Bottmingen', 'Bretzwil',
    'Brislach', 'Bubendorf', 'Buckten', 'Burg im Leimental', 'Buus',
    'Diegten', 'Diepflingen', 'Dittingen', 'Duggingen', 'Eptingen',
    'Ettingen', 'Frenkendorf', 'Füllinsdorf', 'Gelterkinden', 'Giebenach',
    'Grellingen', 'Häfelfingen', 'Hemmiken', 'Hersberg', 'Hölstein',
    'Itingen', 'Känerkinden', 'Kilchberg (BL)', 'Lampenberg', 'Langenbruck',
    'Läufelfingen', 'Laufen', 'Lausen', 'Lauwil', 'Liedertswil',
    'Liesberg', 'Liestal', 'Lupsingen', 'Maisprach', 'Münchenstein',
    'Muttenz', 'Nenzlingen', 'Niederdorf', 'Nusshof', 'Oberdorf (BL)',
    'Oberwil (BL)', 'Oltingen', 'Ormalingen', 'Pfeffingen', 'Pratteln',
    'Ramlinsburg', 'Reigoldswil', 'Reinach (BL)', 'Rickenbach (BL)', 'Roggenburg',
    'Röschenz', 'Rothenfluh', 'Rümlingen', 'Rünenberg', 'Schönenbuch',
    'Seltisberg', 'Sissach', 'Tecknau', 'Tenniken', 'Therwil',
    'Thürnen', 'Titterten', 'Wahlen', 'Waldenburg', 'Wenslingen',
    'Wintersingen', 'Wittinsburg', 'Zeglingen', 'Ziefen', 'Zunzgen',
    'Zwingen',
  ],
  SH: [
    'Bargen (SH)', 'Beggingen', 'Beringen', 'Buchberg', 'Buch (SH)',
    'Büttenhardt', 'Dörflingen', 'Gächlingen', 'Hallau', 'Hemishofen',
    'Löhningen', 'Lohn (SH)', 'Merishausen', 'Neuhausen am Rheinfall', 'Neunkirch',
    'Oberhallau', 'Ramsen', 'Rüdlingen', 'Schaffhausen', 'Schleitheim',
    'Siblingen', 'Stein am Rhein', 'Stetten (SH)', 'Thayngen', 'Trasadingen',
    'Wilchingen',
  ],
  AR: [
    'Bühler', 'Gais', 'Grub (AR)', 'Heiden', 'Herisau',
    'Hundwil', 'Lutzenberg', 'Rehetobel', 'Reute (AR)', 'Schönengrund',
    'Schwellbrunn', 'Speicher', 'Stein (AR)', 'Teufen (AR)', 'Trogen',
    'Urnäsch', 'Wald (AR)', 'Waldstatt', 'Walzenhausen', 'Wolfhalden',
  ],
  AI: [
    'Appenzell', 'Gonten', 'Oberegg', 'Schlatt-Haslen', 'Schwende-Rüte',
  ],
  SG: [
    'Altstätten', 'Amden', 'Andwil (SG)', 'Au (SG)', 'Bad Ragaz',
    'Balgach', 'Benken (SG)', 'Berg (SG)', 'Berneck', 'Buchs (SG)',
    'Bütschwil-Ganterschwil', 'Degersheim', 'Diepoldsau', 'Ebnat-Kappel', 'Eggersriet',
    'Eichberg', 'Eschenbach (SG)', 'Flawil', 'Flums', 'Gaiserwald',
    'Gams', 'Goldach', 'Gommiswald', 'Gossau (SG)', 'Grabs',
    'Häggenschwil', 'Jonschwil', 'Kaltbrunn', 'Kirchberg (SG)', 'Lichtensteig',
    'Lütisburg', 'Marbach (SG)', 'Mels', 'Mörschwil', 'Mosnang',
    'Muolen', 'Neckertal', 'Nesslau', 'Niederbüren', 'Niederhelfenschwil',
    'Oberbüren', 'Oberriet (SG)', 'Oberuzwil', 'Pfäfers', 'Quarten',
    'Rapperswil-Jona', 'Rebstein', 'Rheineck', 'Rorschach', 'Rorschacherberg',
    'Rüthi (SG)', 'Sargans', 'Schänis', 'Schmerikon', 'Sennwald',
    'Sevelen', 'Steinach', 'St. Gallen', 'St. Margrethen', 'Thal',
    'Tübach', 'Untereggen', 'Uznach', 'Uzwil', 'Vilters-Wangs',
    'Waldkirch', 'Walenstadt', 'Wartau', 'Wattwil', 'Weesen',
    'Widnau', 'Wildhaus-Alt St. Johann', 'Wil (SG)', 'Wittenbach', 'Zuzwil (SG)',
  ],
  GR: [
    'Albula/Alvra', 'Andeer', 'Arosa', 'Avers', 'Bergün Filisur',
    'Bever', 'Bonaduz', 'Bregaglia', 'Breil/Brigels', 'Brusio',
    'Buseno', 'Calanca', 'Cama', 'Castaneda', 'Cazis',
    'Celerina/Schlarigna', 'Chur', 'Churwalden', 'Conters im Prättigau', 'Davos',
    'Disentis/Mustér', 'Domat/Ems', 'Domleschg', 'Falera', 'Felsberg',
    'Ferrera', 'Fideris', 'Fläsch', 'Flerden', 'Flims',
    'Furna', 'Fürstenau', 'Grono', 'Grüsch', 'Ilanz/Glion',
    'Jenaz', 'Jenins', 'Klosters', 'Küblis', 'Laax',
    'Landquart', 'Lantsch/Lenz', 'La Punt Chamues-ch', 'Lostallo', 'Lumnezia',
    'Luzein', 'Madulain', 'Maienfeld', 'Malans', 'Masein',
    'Medel (Lucmagn)', 'Mesocco', 'Muntogna da Schons', 'Obersaxen Mundaun', 'Pontresina',
    'Poschiavo', 'Rhäzüns', 'Rheinwald', 'Rongellen', 'Rossa',
    'Rothenbrunnen', 'Roveredo (GR)', 'Safiental', 'Sagogn', 'Samedan',
    'Samnaun', 'Santa Maria in Calanca', 'San Vittore', 'S-chanf', 'Scharans',
    'Schiers', 'Schluein', 'Schmitten (GR)', 'Scuol', 'Seewis im Prättigau',
    'Sils im Domleschg', 'Sils im Engadin/Segl', 'Silvaplana', 'Soazza', 'St. Moritz',
    'Sufers', 'Sumvitg', 'Surses', 'Tamins', 'Thusis',
    'Trimmis', 'Trin', 'Trun', 'Tschappina', 'Tschiertschen-Praden',
    'Tujetsch', 'Untervaz', 'Urmein', 'Val Müstair', 'Vals',
    'Valsot', 'Vaz/Obervaz', 'Zernez', 'Zillis-Reischen', 'Zizers',
    'Zuoz',
  ],
  AG: [
    'Aarau', 'Aarburg', 'Abtwil', 'Ammerswil', 'Aristau',
    'Arni (AG)', 'Auenstein', 'Auw', 'Baden', 'Beinwil am See',
    'Beinwil (Freiamt)', 'Bellikon', 'Bergdietikon', 'Berikon', 'Besenbüren',
    'Bettwil', 'Biberstein', 'Birmenstorf (AG)', 'Birr', 'Birrhard',
    'Birrwil', 'Boniswil', 'Boswil', 'Bottenwil', 'Böttstein',
    'Bözberg', 'Böztal', 'Bremgarten (AG)', 'Brittnau', 'Brugg',
    'Brunegg', 'Buchs (AG)', 'Bünzen', 'Büttikon', 'Buttwil',
    'Densbüren', 'Dietwil', 'Dintikon', 'Dottikon', 'Döttingen',
    'Dürrenäsch', 'Eggenwil', 'Egliswil', 'Ehrendingen', 'Eiken',
    'Endingen', 'Ennetbaden', 'Erlinsbach (AG)', 'Fahrwangen', 'Fischbach-Göslikon',
    'Fisibach', 'Fislisbach', 'Freienwil', 'Frick', 'Full-Reuenthal',
    'Gansingen', 'Gebenstorf', 'Geltwil', 'Gipf-Oberfrick', 'Gontenschwil',
    'Gränichen', 'Habsburg', 'Hägglingen', 'Hallwil', 'Hausen (AG)',
    'Hellikon', 'Hendschiken', 'Herznach-Ueken', 'Hirschthal', 'Holderbank (AG)',
    'Holziken', 'Hunzenschwil', 'Islisberg', 'Jonen', 'Kaiseraugst',
    'Kaisten', 'Kallern', 'Killwangen', 'Kirchleerau', 'Klingnau',
    'Koblenz', 'Kölliken', 'Künten', 'Küttigen', 'Laufenburg',
    'Leibstadt', 'Leimbach (AG)', 'Lengnau (AG)', 'Lenzburg', 'Leuggern',
    'Leutwil', 'Lupfig', 'Magden', 'Mägenwil', 'Mandach',
    'Meisterschwanden', 'Mellikon', 'Mellingen', 'Menziken', 'Merenschwand',
    'Mettauertal', 'Möhlin', 'Mönthal', 'Moosleerau', 'Möriken-Wildegg',
    'Muhen', 'Mühlau', 'Mülligen', 'Mumpf', 'Münchwilen (AG)',
    'Murgenthal', 'Muri (AG)', 'Neuenhof', 'Niederlenz', 'Niederrohrdorf',
    'Niederwil (AG)', 'Oberentfelden', 'Oberhof', 'Oberkulm', 'Oberlunkhofen',
    'Obermumpf', 'Oberrohrdorf', 'Oberrüti', 'Obersiggenthal', 'Oberwil-Lieli',
    'Oeschgen', 'Oftringen', 'Olsberg', 'Othmarsingen', 'Reinach (AG)',
    'Reitnau', 'Remetschwil', 'Remigen', 'Rheinfelden', 'Riniken',
    'Rothrist', 'Rottenschwil', 'Rudolfstetten-Friedlisberg', 'Rüfenach', 'Rupperswil',
    'Safenwil', 'Sarmenstorf', 'Schafisheim', 'Schinznach', 'Schlossrued',
    'Schmiedrued', 'Schneisingen', 'Schöftland', 'Schupfart', 'Schwaderloch',
    'Seengen', 'Seon', 'Siglistorf', 'Sins', 'Sisseln',
    'Spreitenbach', 'Staffelbach', 'Staufen', 'Stein (AG)', 'Stetten (AG)',
    'Strengelbach', 'Suhr', 'Tägerig', 'Tegerfelden', 'Teufenthal (AG)',
    'Thalheim (AG)', 'Uerkheim', 'Uezwil', 'Unterentfelden', 'Unterkulm',
    'Unterlunkhofen', 'Untersiggenthal', 'Veltheim (AG)', 'Villigen', 'Villmergen',
    'Villnachern', 'Vordemwald', 'Wallbach', 'Waltenschwil', 'Wegenstetten',
    'Wettingen', 'Widen', 'Wiliberg', 'Windisch', 'Wittnau',
    'Wohlen (AG)', 'Wohlenschwil', 'Wölflinswil', 'Würenlingen', 'Würenlos',
    'Zeihen', 'Zeiningen', 'Zetzwil', 'Zofingen', 'Zufikon',
    'Zurzach', 'Zuzgen',
  ],
  TG: [
    'Aadorf', 'Affeltrangen', 'Altnau', 'Amlikon-Bissegg', 'Amriswil',
    'Arbon', 'Basadingen-Schlattingen', 'Berg (TG)', 'Berlingen', 'Bettwiesen',
    'Bichelsee-Balterswil', 'Birwinken', 'Bischofszell', 'Bottighofen', 'Braunau',
    'Bürglen (TG)', 'Bussnang', 'Diessenhofen', 'Dozwil', 'Egnach',
    'Erlen', 'Ermatingen', 'Eschenz', 'Eschlikon', 'Felben-Wellhausen',
    'Fischingen', 'Frauenfeld', 'Gachnang', 'Gottlieben', 'Güttingen',
    'Hauptwil-Gottshaus', 'Hefenhofen', 'Herdern', 'Hohentannen', 'Homburg',
    'Horn', 'Hüttlingen', 'Hüttwilen', 'Kemmental', 'Kesswil',
    'Kradolf-Schönenberg', 'Kreuzlingen', 'Langrickenbach', 'Lengwil', 'Lommis',
    'Mammern', 'Märstetten', 'Matzingen', 'Müllheim', 'Münchwilen (TG)',
    'Münsterlingen', 'Neunforn', 'Pfyn', 'Raperswilen', 'Rickenbach (TG)',
    'Roggwil (TG)', 'Romanshorn', 'Salenstein', 'Salmsach', 'Schlatt (TG)',
    'Schönholzerswilen', 'Sirnach', 'Sommeri', 'Steckborn', 'Stettfurt',
    'Sulgen', 'Tägerwilen', 'Thundorf', 'Tobel-Tägerschen', 'Uesslingen-Buch',
    'Uttwil', 'Wagenhausen', 'Wäldi', 'Wängi', 'Warth-Weiningen',
    'Weinfelden', 'Wigoltingen', 'Wilen (TG)', 'Wuppenau', 'Zihlschlacht-Sitterdorf',
  ],
  TI: [
    'Acquarossa', 'Agno', 'Airolo', 'Alto Malcantone', 'Aranno',
    'Arbedo-Castione', 'Arogno', 'Ascona', 'Astano', 'Avegno Gordevio',
    'Balerna', 'Bedano', 'Bedigliora', 'Bedretto', 'Bellinzona',
    'Biasca', 'Bioggio', 'Bissone', 'Blenio', 'Bodio',
    'Bosco/Gurin', 'Breggia', 'Brione sopra Minusio', 'Brissago', 'Brusino Arsizio',
    'Cademario', 'Cadempino', 'Cadenazzo', 'Campo (Vallemaggia)', 'Canobbio',
    'Capriasca', 'Caslano', 'Castel San Pietro', 'Centovalli', 'Cerentino',
    'Cevio', 'Chiasso', 'Coldrerio', 'Collina d\'Oro', 'Comano',
    'Cugnasco-Gerra', 'Cureglia', 'Curio', 'Dalpe', 'Faido',
    'Gambarogno', 'Giornico', 'Gordola', 'Grancia', 'Gravesano',
    'Isone', 'Lamone', 'Lavertezzo', 'Lavizzara', 'Linescio',
    'Locarno', 'Losone', 'Lugano', 'Lumino', 'Maggia',
    'Magliaso', 'Manno', 'Massagno', 'Melide', 'Mendrisio',
    'Mergoscia', 'Mezzovico-Vira', 'Miglieglia', 'Minusio', 'Monteceneri',
    'Morbio Inferiore', 'Morcote', 'Muralto', 'Muzzano', 'Neggio',
    'Novaggio', 'Novazzano', 'Onsernone', 'Origlio', 'Orselina',
    'Paradiso', 'Personico', 'Pollegio', 'Ponte Capriasca', 'Porza',
    'Prato (Leventina)', 'Pura', 'Quinto', 'Riva San Vitale', 'Riviera',
    'Ronco sopra Ascona', 'Sant\'Antonino', 'Savosa', 'Serravalle', 'Sorengo',
    'Stabio', 'Tenero-Contra', 'Terre di Pedemonte', 'Torricella-Taverne', 'Tresa',
    'Vacallo', 'Val Mara', 'Vernate', 'Verzasca', 'Vezia',
    'Vico Morcote',
  ],
  VD: [
    'Aclens', 'Agiez', 'Aigle', 'Allaman', 'Arnex-sur-Nyon',
    'Arnex-sur-Orbe', 'Arzier-Le Muids', 'Assens', 'Aubonne', 'Avenches',
    'Ballaigues', 'Ballens', 'Bassins', 'Baulmes', 'Bavois',
    'Begnins', 'Belmont-sur-Lausanne', 'Belmont-sur-Yverdon', 'Bercher', 'Berolle',
    'Bettens', 'Bex', 'Bière', 'Bioley-Magnoux', 'Blonay - Saint-Légier',
    'Bofflens', 'Bogis-Bossey', 'Bonvillars', 'Borex', 'Bottens',
    'Bougy-Villars', 'Boulens', 'Bourg-en-Lavaux', 'Bournens', 'Boussens',
    'Bremblens', 'Bretigny-sur-Morrens', 'Bretonnières', 'Buchillon', 'Bullet',
    'Bursinel', 'Bursins', 'Burtigny', 'Bussigny', 'Bussy-sur-Moudon',
    'Chamblon', 'Champagne', 'Champtauroz', 'Champvent', 'Chardonne',
    'Château-d\'Œx', 'Chavannes-de-Bogis', 'Chavannes-des-Bois', 'Chavannes-le-Chêne', 'Chavannes-le-Veyron',
    'Chavannes-près-Renens', 'Chavannes-sur-Moudon', 'Chavornay', 'Chêne-Pâquier', 'Cheseaux-Noréaz',
    'Cheseaux-sur-Lausanne', 'Chéserex', 'Chessel', 'Chevilly', 'Chevroux',
    'Chigny', 'Clarmont', 'Coinsins', 'Commugny', 'Concise',
    'Coppet', 'Corbeyrier', 'Corcelles-le-Jorat', 'Corcelles-près-Concise', 'Corcelles-près-Payerne',
    'Corseaux', 'Corsier-sur-Vevey', 'Cossonay', 'Crans (VD)', 'Crassier',
    'Crissier', 'Cronay', 'Croy', 'Cuarnens', 'Cuarny',
    'Cudrefin', 'Cugy (VD)', 'Curtilles', 'Daillens', 'Démoret',
    'Denens', 'Denges', 'Dizy', 'Dompierre (VD)', 'Donneloye',
    'Duillier', 'Dully', 'Echallens', 'Echandens', 'Echichens',
    'Eclépens', 'Ecublens (VD)', 'Epalinges', 'Ependes (VD)', 'Essertines-sur-Rolle',
    'Essertines-sur-Yverdon', 'Etagnières', 'Etoy', 'Eysins', 'Faoug',
    'Féchy', 'Ferreyres', 'Fey', 'Fiez', 'Fontaines-sur-Grandson',
    'Forel (Lavaux)', 'Founex', 'Froideville', 'Genolier', 'Giez',
    'Gilly', 'Gimel', 'Gingins', 'Givrins', 'Gland',
    'Gollion', 'Goumoëns', 'Grancy', 'Grandcour', 'Grandevent',
    'Grandson', 'Grens', 'Gryon', 'Hautemorges', 'Henniez',
    'Hermenches', 'Jongny', 'Jorat-Menthue', 'Jorat-Mézières', 'Jouxtens-Mézery',
    'Juriens', 'L\'Abbaye', 'L\'Abergement', 'La Chaux (Cossonay)', 'La Praz',
    'La Rippe', 'La Sarraz', 'La Tour-de-Peilz', 'Lausanne', 'Lavey-Morcles',
    'Lavigny', 'Le Chenit', 'Le Lieu', 'Le Mont-sur-Lausanne', 'Le Vaud',
    'Les Clées', 'Leysin', 'Lignerolle', 'L\'Isle', 'Lonay',
    'Longirod', 'Lovatens', 'Lucens', 'Luins', 'Lully (VD)',
    'Lussery-Villars', 'Lussy-sur-Morges', 'Lutry', 'Maracon', 'Marchissy',
    'Mathod', 'Mauborget', 'Mauraz', 'Mex (VD)', 'Mies',
    'Missy', 'Moiry', 'Mollens (VD)', 'Molondin', 'Montagny-près-Yverdon',
    'Montanaire', 'Montcherand', 'Montilliez', 'Mont-la-Ville', 'Montpreveyres',
    'Montreux', 'Montricher', 'Mont-sur-Rolle', 'Morges', 'Morrens (VD)',
    'Moudon', 'Mutrux', 'Novalles', 'Noville', 'Nyon',
    'Ogens', 'Ollon', 'Onnens (VD)', 'Oppens', 'Orbe',
    'Orges', 'Ormont-Dessous', 'Ormont-Dessus', 'Orny', 'Oron',
    'Orzens', 'Oulens-sous-Echallens', 'Pailly', 'Paudex', 'Payerne',
    'Penthalaz', 'Penthaz', 'Penthéréaz', 'Perroy', 'Poliez-Pittet',
    'Pompaples', 'Pomy', 'Prangins', 'Premier', 'Préverenges',
    'Prévonloup', 'Prilly', 'Provence', 'Puidoux', 'Pully',
    'Rances', 'Renens (VD)', 'Rennaz', 'Rivaz', 'Roche (VD)',
    'Rolle', 'Romainmôtier-Envy', 'Romanel-sur-Lausanne', 'Romanel-sur-Morges', 'Ropraz',
    'Rossenges', 'Rossinière', 'Rougemont', 'Rovray', 'Rueyres',
    'Saint-Barthélemy (VD)', 'Saint-Cergue', 'Sainte-Croix', 'Saint-George', 'Saint-Livres',
    'Saint-Oyens', 'Saint-Prex', 'Saint-Saphorin (Lavaux)', 'Saint-Sulpice (VD)', 'Saubraz',
    'Savigny', 'Senarclens', 'Sergey', 'Servion', 'Signy-Avenex',
    'Suchy', 'Sullens', 'Suscévaz', 'Syens', 'Tannay',
    'Tartegnin', 'Tévenon', 'Tolochenaz', 'Trélex', 'Trey',
    'Treycovagnes', 'Treytorrens (Payerne)', 'Ursins', 'Valbroye', 'Valeyres-sous-Montagny',
    'Valeyres-sous-Rances', 'Valeyres-sous-Ursins', 'Vallorbe', 'Vaulion', 'Vaux-sur-Morges',
    'Vevey', 'Veytaux', 'Vich', 'Villars-Epeney', 'Villars-le-Comte',
    'Villars-le-Terroir', 'Villars-Sainte-Croix', 'Villars-sous-Yens', 'Villarzel', 'Villeneuve (VD)',
    'Vinzel', 'Vuarrens', 'Vucherens', 'Vufflens-la-Ville', 'Vufflens-le-Château',
    'Vugelles-La Mothe', 'Vuiteboeuf', 'Vulliens', 'Vullierens', 'Vully-les-Lacs',
    'Yens', 'Yverdon-les-Bains', 'Yvonand', 'Yvorne',
  ],
  VS: [
    'Agarn', 'Albinen', 'Anniviers', 'Ardon', 'Ausserberg',
    'Ayent', 'Bagnes', 'Baltschieder', 'Bellwald', 'Betten',
    'Binn', 'Bitsch', 'Blatten', 'Bourg-Saint-Pierre', 'Brig-Glis',
    'Chalais', 'Chamoson', 'Champéry', 'Charrat', 'Chermignon',
    'Collombey-Muraz', 'Conthey', 'Dorénaz', 'Eggerberg', 'Eischoll',
    'Embd', 'Entremont', 'Ergisch', 'Ernen', 'Evolène',
    'Ferden', 'Fiesch', 'Fieschertal', 'Finhaut', 'Fully',
    'Gampel-Bratsch', 'Goms', 'Grône', 'Grächen', 'Grengiols',
    'Guttet-Feschel', 'Hérémence', 'Icogne', 'Inden', 'Isérables',
    'Kippel', 'Lalden', 'Leuk', 'Leukerbad', 'Leytron',
    'Liddes', 'Lötschental', 'Martigny', 'Martigny-Combe', 'Massongex',
    'Monthey', 'Mont-Noble', 'Mörel-Filet', 'Mund', 'Naters',
    'Nax', 'Nendaz', 'Niedergesteln', 'Oberems', 'Obergoms',
    'Orsières', 'Randa', 'Raron', 'Riddes', 'Riederalp',
    'Saas-Almagell', 'Saas-Balen', 'Saas-Fee', 'Saas-Grund', 'Saillon',
    'Saint-Gingolph', 'Saint-Jean', 'Saint-Léonard', 'Saint-Luc', 'Saint-Martin (VS)',
    'Saint-Maurice', 'Salgesch', 'Salins', 'Salvan', 'Savièse',
    'Saxon', 'Sembrancher', 'Sierre', 'Simplon', 'Sion',
    'Stalden (VS)', 'Staldenried', 'Steg-Hohtenn', 'St. Niklaus', 'Täsch',
    'Termen', 'Thel', 'Törbel', 'Troistorrents', 'Turtmann-Unterems',
    'Ulrichen', 'Unterbäch', 'Val-d\'Illiez', 'Varen', 'Venthône',
    'Vétroz', 'Vex', 'Veysonnaz', 'Viège', 'Visp',
    'Visperterminen', 'Vouvry', 'Wiler (Lötschen)', 'Zeneggen', 'Zermatt',
    'Zwischbergen',
  ],
  NE: [
    'Boudry', 'Brot-Dessous', 'La Brévine', 'La Chaux-de-Fonds', 'La Chaux-du-Milieu',
    'La Côte-aux-Fées', 'La Grande Béroche', 'La Sagne', 'La Tène', 'Le Cerneux-Péquignot',
    'Le Landeron', 'Le Locle', 'Les Brenets', 'Les Planchettes', 'Les Ponts-de-Martel',
    'Les Verrières', 'Milvignes', 'Neuchâtel', 'Peseux', 'Rochefort',
    'Saint-Blaise', 'Val-de-Ruz', 'Val-de-Travers', 'Villiers',
  ],
  GE: [
    'Aire-la-Ville', 'Anières', 'Avully', 'Avusy', 'Bardonnex',
    'Bellevue', 'Bernex', 'Carouge', 'Cartigny', 'Céligny',
    'Chancy', 'Chêne-Bougeries', 'Chêne-Bourg', 'Choulex', 'Collex-Bossy',
    'Collonge-Bellerive', 'Cologny', 'Confignon', 'Corsier', 'Dardagny',
    'Genève', 'Genthod', 'Grand-Saconnex', 'Gy', 'Hermance',
    'Jussy', 'Laconnex', 'Lancy', 'Meinier', 'Meyrin',
    'Onex', 'Perly-Certoux', 'Plan-les-Ouates', 'Pregny-Chambésy', 'Presinge',
    'Puplinge', 'Russin', 'Satigny', 'Soral', 'Thônex',
    'Troinex', 'Vandoeuvres', 'Vernier', 'Versoix', 'Veyrier',
  ],
  JU: [
    'Alle', 'Bassecourt', 'Basse-Allaine', 'Boécourt', 'Boncourt',
    'Clos du Doubs', 'Courroux', 'Courrendlin', 'Courtételle', 'Delémont',
    'Develier', 'Fontenais', 'Haute-Ajoie', 'Haute-Sorne', 'La Baroche',
    'Lajoux (JU)', 'Les Bois', 'Les Breuleux', 'Les Enfers', 'Les Genevez',
    'Le Noirmont', 'Mettembert', 'Movelier', 'Moutier', 'Pleigne',
    'Porrentruy', 'Saignelégier', 'Soyhières', 'Val Terbi', 'Vendlincourt',
  ],
};

export function getCommunesByCantonCode(code: string): string[] {
  return COMMUNES_BY_CANTON[code.toUpperCase()] ?? [];
}

// ---------------------------------------------------------------------------
// GE — OCPE crèche presence + taux d'accueil élargi (used by the v11
// "Appliquer données commune → N2" flow). Kept in sync with CommuneTab's
// inline OCPE_DATA constants.
// ---------------------------------------------------------------------------

/** Kids under 4 as share of canton population — Focus n°33, Avril 2025 (~3.84%). */
export const OCPE_PRES_RATE = 20359 / 530246;

/** taux d'accueil élargi (%) by GE commune — Focus n°33, 2024 snapshot. */
export const COMMUNE_TAUX_ELARGIES: Record<string, number> = {
  'Bernex':           36.7,
  'Carouge':          51.4,
  'Chene-Bougeries':  58.3,
  'Confignon':        0,
  'Geneve':           56.1,
  'Grand-Saconnex':   50.0,
  'Lancy':            43.4,
  'Meyrin':           42.6,
  'Onex':             37.9,
  'Plan-les-Ouates':  51.2,
  'Satigny':          34.3,
  'Thonex':           40.9,
  'Vernier':          34.1,
  'Ville de Geneve':  56.1,
};
